export const emptyOrMinLengthRule = (minLength: number) => ({
	name: 'empty-or-min-length',
	validate: (value: string) => value.length === 0 || value.length >= minLength,
});
